import produce from 'immer';
import {
    DROP_CACHED_ORDER_DATA,
    FETCH_ORDER_ERROR,
    FETCH_ORDER_SUCCESS,
    UPDATE_ORDER_EANS_GIFT_STATUSES
} from '../constants';

export const ordersById = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case DROP_CACHED_ORDER_DATA:
            delete state[payload];
            break;

        case FETCH_ORDER_ERROR:
            state[payload] = null;
            break;

        case FETCH_ORDER_SUCCESS:
            state[payload.id] = payload;
            break;

        case UPDATE_ORDER_EANS_GIFT_STATUSES: {
            const { orderId, eansDataChanges } = payload;
            const { items } = state[orderId];
            const updatedEansIds = Object.keys(eansDataChanges);

            items.forEach((ean, eanIndex) => {
                if (updatedEansIds.indexOf(ean.id) > -1) {
                    items[eanIndex].easy_gift_return = eansDataChanges[ean.id];
                }
            });

            break;
        }

        // skip default
    }
}, {});
